import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EnvironmentalAlertPage } from './environmental-alert';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    EnvironmentalAlertPage,
  ],
  imports: [
    IonicPageModule.forChild(EnvironmentalAlertPage),
    ComponentsModule
  ],
})
export class EnvironmentalAlertPageModule {}



// WEBPACK FOOTER //
// ./src/pages/environmental-alert/environmental-alert.module.ts